export default __webpack_public_path__ + "static/media/closet5-before3-480w.5e9a071d.webp";